module.exports = __webpack_public_path__ + "img/poster-zoom-workplace.9a4cba4c.png";